require('ta-semantic-ui/semantic/dist/components/modal.css');
require('ta-semantic-ui/semantic/dist/components/modal.js');

require('ta-semantic-ui/semantic/dist/components/dimmer.css');
require('ta-semantic-ui/semantic/dist/components/dimmer.js');

require('ta-semantic-ui/semantic/dist/components/transition.css');
require('ta-semantic-ui/semantic/dist/components/transition.js');

require('ta-semantic-ui/semantic/dist/components/icon.css');
require('ta-semantic-ui/semantic/dist/components/image.css');


import React, { Component } from 'react'

class Modal extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this)
  }
  componentDidMount() {
    if (this.props.mode === 0) {
      $(this.d).modal()
      this.props.attach(0, this.d)
    } else {
      $(this.u).modal()
      this.props.attach(1, this.u)
    }
  }
  closeModal() {
    if (this.props.mode === 0) {
      $(this.d)
      .modal('hide')
      ;  
    } else {
      $(this.u)
        .modal('hide')
        ;
      }
    }
  render() {
    let thisMode = (this.props.mode === 0) ? 'downvote' : 'upvote'
    return (
      <div className="ui modal" ref={(e) => (this.props.mode === 0) ? (this.d = e) : (this.u = e)}>
          <i className="close icon" onClick={this.closeModal}></i>
          <div className="header">
              {this.props.name} – {this.props.mode === 0 ? 'Verhindern!' : 'Wählen!'}
          </div>
          <div className="image content">
              <div className="image">
                 <img src={this.props.data.img} />
              </div>
          <div className="description">
              {this.props.data[thisMode]}
          </div>
        </div>
      </div>
    )
  }
}

export default Modal


// WEBPACK FOOTER //
// ./src/components/custom/modal/Modal.js